import { toast, Toaster } from "react-hot-toast";

import Alert from "./Alert";

const toastStyle = {
  background: "transparent",
  boxShadow: "none",
  padding: 0,
  maxWidth: "100%",
  width: "100%",
};

function customToast(message, intent = "success", options = {}) {
  toast.custom(
    (t) => (
      <div className="w-full max-w-full">
        <Alert intent={intent} text={message} visible={t.visible} fullWidth />
      </div>
    ),
    { duration: 3500, ...options }
  );
}

export function AppToaster({ withAppHeader = false }) {
  return (
    <Toaster
      position="top-center"
      containerClassName={`app-toaster${
        withAppHeader ? " app-toaster--with-header" : ""
      }`}
      toastOptions={{
        duration: 3500,
        style: toastStyle,
      }}
      gutter={10}
    />
  );
}

export default customToast;
